const state = () => ({
  activeModal: false,
  activePage: '',
  confirmModal: {
    options: null,
    opened: false,
    resolve: null,
    reject: null
  },
  modalArguments: null,
  modalParams: false
})

const getters = {
  modalParams: state => state.modalParams,
  modalArguments: state => state.modalArguments,
  activeModal: state => state.activeModal
}

const mutations = {
  ACTIVE_MODAL (state, modal) {
    state.activeModal = modal
  },
  MODAL_PARAMETER (state, parameters) {
    state.modalParams = parameters
  },
  MODAL_ARGUMENTS (state, arg) {
    state.modalArguments = arg
  },
  CLOSE_MODAL (state, modal) {
    state.activeModal = false
    state.modalArguments = null
    state.modalParams = false
  }
}

const actions = {
  open ({ commit }, modal) {
    document.body.classList.add('u-no-scroll')

    if (typeof modal === 'object') {
      commit('MODAL_PARAMETER', modal.params)

      if (modal.args) {
        commit('MODAL_ARGUMENTS', modal.args)
      }
      modal = modal.name
    }

    commit('ACTIVE_MODAL', modal)
  },
  close ({ commit }) {
    document.body.classList.remove('u-no-scroll')

    commit('CLOSE_MODAL')

    return new Promise(resolve => {
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
